import { render, staticRenderFns } from "./ImpactOfDisabilityResults.vue?vue&type=template&id=fc57f52c&scoped=true"
import script from "./ImpactOfDisabilityResults.vue?vue&type=script&lang=js"
export * from "./ImpactOfDisabilityResults.vue?vue&type=script&lang=js"
import style0 from "./ImpactOfDisabilityResults.vue?vue&type=style&index=0&id=fc57f52c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc57f52c",
  null
  
)

export default component.exports